export default __webpack_public_path__ + "static/media/1k.9640a4a0.gif";